<template>
  <div class="fullpage-container">
    <div class="fullpage-wp" v-fullpage="opts" ref="fullPage">
      <div class="page-1 page rel bg-bottom bg-cover" style="background-color:#001c52;">
        <Topbar />
        <div class="page-main fs20 color-white tc">
          <div v-animate="{ value: 'zoomIn' }" style="margin:0 0 -0.3rem">
            <div>多种类型广告驱动</div>
            <div>精准触达目标用户</div>
          </div>
          <img
            src="https://static.wkanx.com/w002/M00/05/F4/CgIXlV6dhpGARLYRAAINRNnmBe4715.png"
            style="height:3.53rem;"
          />
        </div>
        <div class="page-footer">
          <Contact type="info" class="m-b-4" />
          <NextPage type="1" @next="moveNext" />
        </div>
      </div>
      <div class="page-2 page color-primary">
        <Header />
        <div class="page-main tc">
          <div class="rfs14" style="margin:0 0 .25rem">信息流广告</div>
          <div class="rfs12 color-default tl">
            信息流广告是指WiFi万能钥匙资讯信息流中，穿插展示的原生广告 根据用户兴趣推荐，更加自然高效
          </div>
          <div class="color-default" flex="cross:bottom">
            <div class="m-r-3 oh">
              <img
                src="https://static.wkanx.com/w002/M00/05/B2/CgIXlV6EF_mAQu8WAABtnHgxXpE332.png"
                style="width:0.9rem;transform:translate3d(0px, 46px, 0px);"
              />
              <div class="rfs12 img-txt rel oh">详情页横幅</div>
            </div>
            <div class="m-r-3 oh">
              <img
                src="https://static.wkanx.com/w002/M00/05/B2/CgIXGF6EGlyADKxtAADGph6fFO8036.png"
                style="width:1.1rem;transform:translate3d(0px, 60px, 0px);"
              />
              <div class="rfs12 img-txt rel oh">信息流</div>
            </div>
            <div class="oh">
              <img
                src="https://static.wkanx.com/w002/M00/05/B2/CgIXGF6EGn2AEqMAAAB5SVhFXiI109.png"
                style="width:0.9rem;transform:translate3d(0px, 76px, 0px);"
              />
              <div class="rfs12 img-txt rel oh">底部全屏</div>
            </div>
          </div>
        </div>
        <div class="page-footer">
          <Contact class="m-b-2" />
          <NextPage @next="moveNext" />
        </div>
      </div>
      <div class="page-3 page color-primary" style="background:#52b1ff;">
        <Header type="2" menuType="light" />
        <div class="page-main full-width color-white inner">
          <div class="rfs12 tc" style="padding: 0 0 .25rem;">大幅面广告</div>
          <div class="rfs12" style="padding: 0 0 .3rem;">
            大幅面广告是指在WiFi万能钥匙产品中，以开屏、横幅、浮层等相对幅面较大的广告展现形式，以更具视觉冲击力的广告形式进行品牌曝光
          </div>
          <div class="tc rfs12 color-white" flex="cross:bottom main:center">
            <div class="oh">
              <img
                src="https://static.wkanx.com/w002/M00/05/B2/CgIXgV6EHTiAEZq2AAAmTfokLXI958.png"
                style="width:0.76rem;"
              />
              <div>连接页广告</div>
            </div>
            <div class="oh" style="margin:0 0 0 -0.38rem;">
              <img
                src="https://static.wkanx.com/w002/M00/05/B2/CgIXGF6EHSyAF2j6AAD1vGXtcuw749.png"
                style="width:1.83rem;"
              />
              <div>开屏</div>
            </div>
            <div class="rel oh" style="margin:0 0 0 -0.32rem;">
              <img
                src="https://static.wkanx.com/w002/M00/05/B2/CgIXlV6EHUqAfCzkAABbtrQAH_k004.png"
                style="width:0.86rem;"
              />
              <div>浮层</div>
            </div>
          </div>
        </div>
        <div class="page-footer">
          <Contact type="info" class="m-b-2" />
          <NextPage type="1" @next="moveNext" />
        </div>
      </div>
      <div class="page-4 page color-primary">
        <Header />
        <div class="page-main tc inner">
          <div class="rfs12 tc" style="margin:0 0 .3rem;">沉浸式视频广告</div>
          <div class="rfs12 tl color-default" style="padding: 0 0 .3rem;">
            沉浸式视频广告是指，在WiFi万能钥匙产品资讯信息流中，以沉浸式视频的广告形式通过视频吸引用户点击，从而达到客户的商业需求效果
          </div>
          <img
            class="db bc"
            src="https://static.wkanx.com/w002/M00/05/B2/CgIXGF6EHvWAGGF5AAD8QTZ44kM081.png"
            style="width:3.25rem;"
          />
          <div class="rfs12 tl m-v-2 color-default">
            下载类广告：可点击底部“立即下载”按钮下载广告对应的APP应用
          </div>
          <img
            class="db bc"
            src="https://static.wkanx.com/w002/M00/05/B3/CgIXgV6EH0GAbZ0_AAESjay8QWc276.png"
            style="width:1.9rem;"
          />
          <div class="rfs12 tl m-t-2 color-default">
            跳转类广告：可点击底部“查看详情”按钮跳转至广告落地页
          </div>
        </div>
        <Contact class="page-footer m-b-2" />
      </div>
    </div>
  </div>
</template>
<script>
import Base from './Base';

export default {
  name: '',
  props: {},
  extends: Base,
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang='scss' scoped>
.page-2 {
  .img-txt {
    box-shadow: rgb(255, 255, 255) 0px -10px 25px 25px;
    background: #fff;
    transform: translateZ(0);
  }
}
</style>
